import { createEventEmmiter } from './event_emitter.js';
import { EventBus } from './event_bus.js';
export function EventEmitterMixin(base, useGlobalBus = false) {
    return class EventBusClient extends base {
        emitter = useGlobalBus ? EventBus : createEventEmmiter();
        eventNames() {
            return this.emitter.eventNames();
        }
        listeners(event) {
            return this.emitter.listeners(event);
        }
        listenerCount(event) {
            return this.emitter.listenerCount(event);
        }
        emit(event, ...args) {
            return this.emitter.emit(event, ...args);
        }
        on(event, callable, context) {
            this.emitter.on(event, callable, context);
            return this;
        }
        addListener(event, callable, context) {
            this.emitter.addListener(event, callable, context);
            return this;
        }
        off(event, callable, context, once) {
            this.emitter.off(event, callable, context, once);
            return this;
        }
        removeListener(event, callable, context, once) {
            this.emitter.removeListener(event, callable, context, once);
            return this;
        }
        once(event, callable, context) {
            this.emitter.once(event, callable, context);
            return this;
        }
        removeAllListeners(event) {
            this.emitter.removeAllListeners(event);
            return this;
        }
    };
}
//# sourceMappingURL=event_emitter_mixin.js.map